import 'isomorphic-fetch'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import experiment from '../actions/experiment'

import routeHelpers from '../helpers/routeHelpers'
import trackingHelpers from '../helpers/trackingHelpers'

import config from '../configs/config'

import MarketingPreferences from './MarketingPreferences'

const { brandConfig } = config

class PreferenceCentre extends Component {
  constructor (props) {
    super(props)
    this.updatePreferences = this.updatePreferences.bind(this)
  }

  componentDidMount () {
    if (window && window.tracker) {
      tracker.page(
        'post_booking', {
          page_type: 'extra_details'
        }
      )
      // This will call the action to complete a specific experiment as per how tracker works
      // https://github.com/holidayextras/tracker#split-tets
      // It is important to note here that because we are calling in the componentDidMount
      // that any split tests in this file will not be accounted for as they will fire after this function call.
      // I do not know a solution to this problem yet but as we don't have split tests in the file right now
      // I am not going to address it yet... sorry. Rob H. 15/05/19
      this.props.completeExperiment('EXP-018:AltonPriceFinder')
      this.props.completeExperiment('EXP-019:LegolandPriceFinder')
      this.props.completeExperiment('EXP-020:AvailabilityMoreInfoModalButton')
    }
  }

  componentDidUpdate () {
    if (window && window.tracker && this.props.lineItems.length > 0) {
      tracker.track('ecommerce', {
        method: 'new',
        basket: {
          products: this.props.lineItems.map(item => {
            return {
              category: item.category,
              currency: item.currency,
              id: this.props.orderId,
              name: item.name,
              price: item.price * 100,
              quantity: item.quantity,
              sku: item.id
            }
          })
        }
      })
    }
  }

  updatePreferences (event) {
    if (event) event.preventDefault()

    const params = {
      body: JSON.stringify({
        allowGeneralMarketing: this.props.allowGeneralMarketing,
        allowOrderMarketing: this.props.allowOrderMarketing
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    }

    return fetch(`/ordersUpdate/${this.props.orderId}`, params)
      .then(response => {
        if (response.status >= 200 && response.status < 300) {
          const url = this.props.isCallCentre ? `https://monstersinc.holidayextras.co.uk/monstersinc/r/welcome?product=book&task=masterTemplateViewAmendCancel&getHistory=true&transactionReference=${this.props.orderId}` : `/confirmation/${this.props.orderId}/${this.props.customerId}`
          routeHelpers.navigateTo(url)
        }
      })
      .catch(error => console.error('Updating preferences has resulted in an error:', error))
  }

  render () {
    return (
      <div className='row'>
        <div className='col-lg-8 col-lg-offset-2'>
          <div className='panel panel-default'>
            <div className='panel-body'>
              <FormattedMessage id='preferenceCentre.selectPreferencesTitle' tagName='h2' />
              <p>
                <FormattedMessage id='preferenceCentre.bookingMade' values={{ parkName: brandConfig.name }} />
              </p>
              <form onSubmit={this.updatePreferences} className='form-horizontal'>
                <fieldset>
                  <MarketingPreferences />
                </fieldset>
                <fieldset>
                  <div>
                    <div className='row'>
                      <div className='col-md-6 col-md-offset-3'>
                        <Button
                          type='submit'
                          block
                          bsSize='large'
                          bsStyle='primary'
                          {...trackingHelpers.getAttributes('View Confirmation', 'Preference Centre', '1')}
                        >
                          <FormattedMessage id='preferenceCentre.viewConfirmation' />
                        </Button>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

PreferenceCentre.propTypes = {
  completeExperiment: PropTypes.func.isRequired
}

PreferenceCentre.defaultProps = {
  completeExperiment: () => {}
}

function mapStateToProps (state) {
  return {
    allowGeneralMarketing: state.preferenceCentre.allowGeneralMarketing,
    allowOrderMarketing: state.preferenceCentre.allowOrderMarketing,
    customerId: state.preferenceCentre.customerId,
    orderId: state.preferenceCentre.orderId,
    lineItems: state.preferenceCentre.lineItems,
    grossPrice: state.preferenceCentre.grossPrice
  }
}

function mapDispatchToProps (dispatch) {
  return {
    completeExperiment: (experimentName) => dispatch(experiment.complete(experimentName))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferenceCentre)
export {
  PreferenceCentre
}
